import { Box, Stack, Typography } from "@mui/material";
import { DebugBox, LoadingBox, safeFormatDate, useNavigateWithParams } from "@northpowerdev/np-react-utils";
import { useState, useEffect } from "react";

import { StyledDataGrid } from "./DlspStyledDataGrid";
import { hikoAlert } from "../../../utils/HikoAlert";
import { plural } from "../../../utils/utilityFunctions";
import useFetchJson from "../../../data/useFetchJson";


const isoDateStringFormatter = (formatterParams) => safeFormatDate(formatterParams.value, 'd MMM h:mmaaa ')

const gridColumns = [
    { field: 'landownerPermissionDate', headerName: 'Last Updated Date', flex: 1, valueFormatter: isoDateStringFormatter, maxWidth: 150 },
    { field: 'landownerPermission', headerName: 'Updated By', flex: 1, maxWidth: 150 },
    { field: 'status', headerName: 'Status', flex: 1, maxWidth: 100 },
    { field: 'landownerPermissionReceived', headerName: 'Permission Received', flex: 1, maxWidth: 150 },
    { field: 'icp', headerName: 'ICP', flex: 1, minWidth: 150, maxWidth: 150 },
    { field: 'address', headerName: 'Address', flex: 1 },
    { field: 'landowners', headerName: 'Land Owner Contacts', flex: 1 },
];

export default function DlspLandOwnerPermissionTaskList() {

    const [orderedTaskList, setOrderedTaskList] = useState([])
    const getTaskListPath = '/bff/decommissioned-lines-service/api/decommissioned-lines/list-landowner-tasks'
    const getTaskListParams = {
        pageIdx: 0,
        pageSize: 1000,
    }
    const {
        isLoading: taskListLoading,
        data: taskList, // [{..., "icp", "status", "stormArea", "dsubSuburb", "address", "decommissionDate", "landOwnerContacts", "landownerPermissionBy", "landownerPermissionDate", "landOwnerPermissionRequired", "permissionReceived", ...}, ...]
    } = useFetchJson(getTaskListPath, {params: getTaskListParams}, true)
    const navigateToTaskDetails = useNavigateWithParams('/dlsp/task/details')

    useEffect(() => {
        if (!taskList) return

        setOrderedTaskList([...taskList].map((listTask) => {
            const viewTask = {
                landownerPermissionDate: listTask.landownerPermissionDate,
                landownerPermission: listTask.landownerPermissionBy,
                status: listTask.status,
                icp: listTask.icp,
                address: listTask.address,
                landowners: listTask.landownerPermission?.landOwnerContacts,
                landownerPermissionReceived: (listTask.landownerPermission?.permissionReceived === 'Yes' ? 'Yes' : 'No'),
            }
            return viewTask
        }).filter((viewTask) => {
            //
            // Remove tasks where permission has already bee received
            //
            return viewTask.status !== 'Remedial'
        }).sort((a, b) => {
            //
            // Put into alphabetical order, which maps to reverse chronological order for dates
            //
            return (b.landownerPermissionDate || '').localeCompare(a.landownerPermissionDate || '')
        })
        )

    }, [taskList])
    const handleRowClick = (params, event, details) => {
        console.log('handleRowClick', { params, event, details })
        if (!params.row.icp) {
            hikoAlert('No icp in that row!')
            return
        }
        let navigateParams = { icp_number: params.row.icp }
        navigateToTaskDetails(navigateParams)
    }

    return (
        <Box className="Page">
            <h3>Decommissioned Lines Safety Project</h3>
            <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'left' }}>
                <h2>Land Owner Permission Tasks</h2>
            </Stack>

            <LoadingBox loading={taskListLoading}>

                <Typography variant="body1">We found {orderedTaskList?.length || 'no'} task{plural(orderedTaskList?.length)}.</Typography>

                <StyledDataGrid sx={{ my: 2 }} autoHeight rows={orderedTaskList || []}
                    getRowId={(row) => row.icp}
                    columns={gridColumns}
                    onRowClick={handleRowClick}
                    getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'}
                />
                <DebugBox title="taskList" stringify>{taskList}</DebugBox>
            </LoadingBox>


        </Box>
    )
}